import { create } from '@bufbuild/protobuf'
import { t } from 'i18next'

import { SimulateOrdersResponse } from '@enechain/eposition-proto/bffportal/v1/simulation_service_pb'
import {
  StatusLabel,
  StatusLabelSchema,
  StatusLabel_Status,
} from '@enechain/eposition-proto/bfftypes/v1/label_pb'

export type ResultSimulationForOption2Model = {
  relationNumber: string
  orderRelationString: string
  allowDeal: boolean
  allowDealStatus: StatusLabel
  allRiskAmount: string
  allLimitAmount: string
  allAvailableAmount: string
  physicalFuturesRiskAmount: string
  physicalFuturesLimitAmount: string
  physicalFuturesAvailableAmount: string
}

export function convertResultSimulationForOption2Model(
  response: SimulateOrdersResponse,
): ResultSimulationForOption2Model[] {
  console.log(response)
  return response.outputs.map((output) => {
    return {
      relationNumber:
        output.relationNumber === 0 ? '-' : output.relationNumber.toString(),
      orderRelationString:
        output.orders.length > 0
          ? output.orders.map((order) => order.orderNumber).join(',')
          : '-',
      allowDeal: output.checkCreditRiskResults?.overallAllowed ?? false,
      allowDealStatus:
        output.checkCreditRiskResults?.overallAllowed !== undefined
          ? output.checkCreditRiskResults.overallAllowed
            ? create(StatusLabelSchema, {
                status: StatusLabel_Status.POSITIVE,
                label: t('domain:model.deal.deal_available.available'),
              })
            : create(StatusLabelSchema, {
                status: StatusLabel_Status.NEGATIVE,
                label: t('domain:model.deal.deal_available.unavailable'),
              })
          : create(StatusLabelSchema, {
              status: StatusLabel_Status.UNSPECIFIED,
              label: '-',
            }),
      allRiskAmount: Number(
        output.checkCreditRiskResults?.allResult?.riskAmount ?? 0,
      ).toLocaleString(),
      allLimitAmount: Number(
        output.checkCreditRiskResults?.allResult?.limitAmount ?? 0,
      ).toLocaleString(),
      allAvailableAmount: Number(
        output.checkCreditRiskResults?.allResult?.availableAmount ?? 0,
      ).toLocaleString(),
      physicalFuturesRiskAmount: Number(
        output.checkCreditRiskResults?.physicalFuturesResult?.riskAmount ?? 0,
      ).toLocaleString(),
      physicalFuturesLimitAmount: Number(
        output.checkCreditRiskResults?.physicalFuturesResult?.limitAmount ?? 0,
      ).toLocaleString(),
      physicalFuturesAvailableAmount: Number(
        output.checkCreditRiskResults?.physicalFuturesResult?.availableAmount ??
          0,
      ).toLocaleString(),
    }
  })
}
